import React, { useCallback, useContext } from 'react';
import { push } from 'connected-react-router';
import { useDispatch, useSelector } from 'react-redux';

import { uploadBatch } from '@actions/batch-actions';
import { openDashboardDialog } from '@actions/dashboard-actions';

import BatchContext from '@components/batch/batch-upload-edit/batch-context';
import * as dialog from '@constants/dialogs';

import { getErrorsCount } from '@selectors/batch-edit-selector';

import DialogActions from '@shared/dialogs/dialog-actions';

import { convertBatchToFile } from '@utils/batch-utils';

const TopBarBatchUploadEditActions = () => {
  const dispatch = useDispatch();
  const { fileId } = useContext(BatchContext);
  const batch = useSelector(state => state.batchEdit[fileId]);
  const {
    map_category_type: categoryTypes,
    map_category: categories
  } = useSelector(state => state.dataTypes);
  const hasErrors = useSelector(state => getErrorsCount(state, fileId)) > 0;

  const onCancel = useCallback(
    () => {
      dispatch(push('/library/batch'));
    },
    [dispatch]
  );

  const onUpload = useCallback(
    () => {
      if (!batch) {
        return;
      }
      window.savingBatchUpload = true;
      const file = convertBatchToFile(batch, categoryTypes, categories);
      const upload = {
        active: true,
        file,
        entityType: batch.entityType,
        status: 0
      };
      dispatch(uploadBatch(upload, null, null));
      dispatch(push({
        pathname: '/library/batch',
        state: { poll: true }
      }));
      window.savingBatchUpload = false;
    },
    [batch, categories, categoryTypes, dispatch]
  );

  const openUploadDialog = useCallback(
    () => dispatch(openDashboardDialog(dialog.UPLOAD_BATCH, { onUpload })),
    [dispatch, onUpload]
  );

  return (
    <DialogActions
      disabledSubmit={hasErrors}
      onCancel={onCancel}
      onSubmit={openUploadDialog}
      submitLabel="UPLOAD"
      submitTooltip={hasErrors ? 'Please fix all the errors before uploading.' : null}
    />
  );
};

export default TopBarBatchUploadEditActions;
